<div nz-row nzGutter="25">
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div
      class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Basic Usage</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-auto-complete-basic></nz-demo-auto-complete-basic>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div
      class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Customized</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-auto-complete-options></nz-demo-auto-complete-options>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div
      class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Customize Input Component</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-auto-complete-custom></nz-demo-auto-complete-custom>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div
      class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Lookup-Patterns - Uncertain Category</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-auto-complete-uncertain-category></nz-demo-auto-complete-uncertain-category>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div
      class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Lookup-Patterns - Certain Category</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-auto-complete-certain-category></nz-demo-auto-complete-certain-category>
      </div>
    </div>
  </div>
</div>
